import Button from 'app/components/Buttons/Button';
import useLazyLoad from 'app/components/hooks/useLazyLoad';
import usePageProps from 'app/components/hooks/usePageProps';
import Layout from 'app/components/Layouts/Layout'
import { ModalsContext, MODALS } from 'app/components/Layouts/Modals';
import { UserType } from 'app/components/Types/UserType';
import IconText from 'app/fragments/IconText';
import { LineButton } from 'app/fragments/LineButton';
import { TaskCard } from 'app/fragments/TaskCard';
import { UserCard } from 'app/fragments/UserCard';
import React, { useContext } from 'react'
import route from 'ziggy-js';

interface Props { }

function Index(props: Props) {

    const [users, button, meta, form, setTask] = useLazyLoad<UserType>('users');

    let { open } = useContext(ModalsContext)
    const { user } = usePageProps<{ user: UserType }>();

    return (
        <Layout className="text-white" heading="Team">
            <div className="flex justify-between mt-40px">
                <div className='flex items-center justify-between w-full'>
                    <h2 className="text-24 font-bold">Your Team</h2>
                    <Button href={route('user.create')}>New User</Button>
                </div>
                {/* <div>
                    <div></div>
                    <a className="cursor-pointer" onClick={() => {}}><IconText className="bg-green-539648 text-white py-12px px-16px rounded-full text-16 font-medium" icon="plus" text="Add Member" /></a>
                </div> */}
            </div>
            <div className="mt-16px text-16 text-[#CCCCCC]">
                {/* seems like you're a firefighter today, <span className='font-bold'>go extinguish those pesky fires 🔥</span>! */}
            </div>
            <div className="grid grid-cols-3 gap-30px py-60px mob:grid-cols-1 mob:gap-16px">
                {/* <div onClick={(e) => { e.preventDefault(); open(MODALS.NEWTASK) }} className="fixed top-1/2 cursor-pointer right-50px w-50px h-50px bg-blue-700 rounded-full flex items-center justify-center">
                    <Icon className={"transform rotate-45 w-16px"} name="cross" />
                </div> */}

                {
                    users.map(u =>
                        <UserCard user={u} />
                    )
                }
            </div>
            {button && <LineButton {...button} text={`Show more (${meta.next})`} href={"#"} showing={{ max: meta.total, current: meta.to }} />}
            {/* {
                meta &&
                <div className="flex justify-center my-20px">
                    <div className="text-white text-16">Zobrazuji {meta.to} z {meta.total}</div>
                </div>
            } */}
        </Layout>
    )
}

export default Index
